__turbopack_context__.v({
  "categoryItemsList": "prematch-categories-container-module-sass-module__rqP5ZG__categoryItemsList",
});
